'use strict';

module.exports = {
    desktop: {
        dp: {
            home: [],
            dp: ['dp_search_summary'],
            secure: [],
        },
        flights: {
            secure: [],
            home: [],
        },
        trains: {
            secure: [],
            home: ['membership_login_bubble'],
        },
        upsell: {
            secure: [],
            home: [],
        },
        hotels: {
            hotels: [],
        },
        deals: {
            deals: [],
        },
        of2Iframe: {
            of2Iframe: [],
        },
    },
    mobile: {
        dp: {
            home: ['edit_option_meta', 'flights_rating'],
            dp: [''],
            secure: [''],
        },
        flights: {
            secure: [],
            home: ['edit_option_meta', 'flights_rating'],
        },
        trains: {
            secure: [],
            home: ['edit_option_meta', 'flights_rating'],
        },
        upsell: {
            secure: [],
            home: ['flights_rating'],
        },
        hotels: {
            hotels: [],
        },
        deals: {
            deals: [],
        },
        of2Iframe: {
            of2Iframe: [],
        },
    },
};
